var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.extra.attachments),function(attachment){return _c('v-flex',{staticClass:"pl-2",attrs:{"xs4":""}},[_c('file-display',{attrs:{"src":attachment}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }